module.exports = __webpack_public_path__ + "static/media/SF_nn_sentrert_logo_innlandet_pos.52897cc1.png";